// Onboarding de un número nuevo a WhatsApp Cloud API, directo con Meta
// (roadmap#2097). Convive con el flujo Coexistence: se entra con `?mode=cloud`.

export const WHATSAPP_CLOUD_MODE_PARAM = 'cloud';

export const WHATSAPP_CLOUD_FLAG = 'feature.2097.whatsapp-cloud-onboarding';

/** Configuración de Facebook Login for Business para Cloud API (Embedded Signup v4). */
export const WHATSAPP_CLOUD_CONFIG_ID = process.env.FB_CLOUD_CONFIG_ID || '';

const KORI_URLS: Record<string, string> = {
  prod: 'https://kori.cliengo.com',
  stage: 'https://kori.stagecliengo.com',
};

export const KORI_URL =
  process.env.KORI_URL || KORI_URLS[process.env.ENVIRONMENT || ''] || KORI_URLS.stage;

/** Somos Tech Provider: el cliente carga su método de pago en la WABA. */
export const WHATSAPP_MANAGER_PAYMENT_URL =
  'https://business.facebook.com/wa/manage/home/';

/** Números de la WABA en WhatsApp Manager: ahí se cambia o desactiva el PIN de 2 pasos. */
export const whatsappManagerPhoneNumbersUrl = (wabaId?: string) =>
  `https://business.facebook.com/latest/whatsapp_manager/phone_numbers${
    wabaId ? `?asset_id=${wabaId}` : ''
  }`;

/** `reason` que devuelve kori en los errores del onboarding. */
export const CLOUD_ONBOARDING_ERRORS = {
  CODE_EXCHANGE_FAILED: 'code_exchange_failed',
  PHONE_NUMBER_IN_USE: 'phone_number_in_use',
  NUMBER_ON_BUSINESS_APP: 'number_on_business_app',
  TWO_STEP_PIN_REQUIRED: 'two_step_pin_required',
  META_ERROR: 'meta_error',
} as const;

export const CLOUD_ONBOARDING_MESSAGES: Record<string, string> = {
  [CLOUD_ONBOARDING_ERRORS.CODE_EXCHANGE_FAILED]:
    'No pudimos validar la conexión con Meta. Prueba de nuevo.',
  [CLOUD_ONBOARDING_ERRORS.PHONE_NUMBER_IN_USE]:
    'Este número ya está conectado en otra cuenta de Cliengo.',
  [CLOUD_ONBOARDING_ERRORS.NUMBER_ON_BUSINESS_APP]:
    'Este número está en la app WhatsApp Business. Conéctalo desde "WhatsApp Business (Coexistence)".',
  [CLOUD_ONBOARDING_ERRORS.META_ERROR]:
    'Meta no pudo completar la conexión. Prueba de nuevo en unos minutos.',
  missing_phone_number:
    'No terminaste de verificar el número en Meta. Vuelve a conectar y completa la verificación.',
  unknown: 'No pudimos conectar el número. Prueba de nuevo.',
};
